<template>
  <div class="gate" :class="'gate--' + band.kind" :role="live ? 'status' : 'note'">
    <i class="material-icons" aria-hidden="true">{{ band.icon }}</i>
    <div class="gate__body">
      <p class="gate__title">{{ band.title }}</p>
      <p class="gate__detail">{{ band.detail }}</p>
    </div>
  </div>
</template>

<script>
  /*
   * The pairing verdict. The design states it twice - a loud band at the top of the pairing
   * section and a second band at the foot next to Generate - and both are rendered from the same
   * model so they cannot disagree. Only the foot band is a live region, so a change is announced
   * exactly once.
   */
  export default {
    name: 'RpdVerdictBand',

    props: {
      band: {
        type: Object,
        required: true,
      },
      live: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
